import { H2, H3 } from "../components/Text";
import Button from "../components/Button";
import Logo from "../images/Pronouns compass/Svgs/Logo";
import "./Welcome.css";
import Menu from "../components/Menu";

const Welcome = ({ start }) => (
  <div style={{ textAlign: "center" }}>
    <div style={{ paddingTop: "10px" }}>
      <Logo width={"100%"} height={"50%"} id={"logo"} />
    </div>
    <H2 className="welcome">Welcome!</H2>
    <div className="introduction-container">
      <H3 className="introduction-text">
        Discover your very own Pride flag, created just for you!
      </H3>
    </div>
    <div className="introduction-container">
      <H3 className="introduction-text">
        Choose what to add, and share it with the world!
      </H3>
    </div>
    <div
      className="button-container"
      style={{
        display: "flex",
        justifyContent: "space-evenly",
        marginTop: "20px",
      }}
    >
      <div
        onClick={() => {
          start();
        }}
      >
        <Button type={"start"} className="start-button" enabled="true"></Button>
      </div>
    </div>
    <Menu />
  </div>
);

export default Welcome;
